import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import copy from 'clipboard-copy';
import shareIcon from '../images/shareIcon.svg';

function ShareButton({ recipe: { id, name, type }, index }) {
  const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin;

  const shareClick = ({ target: { value } }) => {
    copy(value);
    toast.success('Link copied!');
  };

  return (
    <input
      type="image"
      alt={ `Compartilhar receita de ${name}` }
      src={ shareIcon }
      onClick={ shareClick }
      data-testid={ `${index}-horizontal-share-btn` }
      value={ `${baseUrl}/${type}s/${id}` }
    />
  );
}

ShareButton.propTypes = {
  recipe: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

export default ShareButton;
